import { StyleSheet } from 'react-native';
import Theme from 'Theme';

const baseStyles = {
    previewImage: {
        position: 'absolute',
        ...StyleSheet.absoluteFill,
        flex: 1,
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        backgroundColor: Theme.primaryBackgroundColor
    },
    infoContent: {
        alignSelf: 'stretch',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        with: '100%'
    },
    buttonsContainer: {
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
        marginTop: 15,
        width: '100%'
    },
    backButton: {
        paddingRight: 20
    },
    checkboxContainer: {
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'stretch',
        // marginBottom: 36,
        marginTop: '3%'
    },
    checkboxText: {
        color: '#ffffff',
        marginLeft: 12,
        fontFamily: Theme.regularFont,
        fontSize: 18
    }
};

export default StyleSheet.create(baseStyles);
